module.exports = __webpack_public_path__ + "img/EPS.65cd3c69.svg";